/**
 * Created by slava on 06.09.2026
 */

// Hover feedback for aisensia games: a single grow-and-return pulse when the pointer enters a
// target, instead of cleverapps' held interactive scale (enlarged until the pointer leaves).
// Same amplitude as the held scale (MaxInteractiveScale). Press feedback is unchanged: the
// generic handler still shrinks, cleverapps.UI.Button still grows. A release while the pointer
// stays over the target returns to base without a new pulse: the pulse fires only on entry.
//
// Timings are class constants, not styles: cleverapps.UI.updateSizes would scale and round them.
PointerHandler.HOVER_PULSE = { up: 0.06, down: 0.1 };
PointerHandler.HOVER_PULSE_TAG = 19;

PointerHandler.runHoverPulse = function (target) {
    PointerHandler.stopHoverPulse(target);

    const maxScale = MaxInteractiveScale(target);
    const baseScale = BaseScale(target);
    const timings = PointerHandler.HOVER_PULSE;

    target.setScale(baseScale.x, baseScale.y);

    const pulse = new cc.Sequence(
        new cc.ScaleTo(timings.up, baseScale.x * maxScale, baseScale.y * maxScale).easing(cc.easeOut(2)),
        new cc.ScaleTo(timings.down, baseScale.x, baseScale.y).easing(cc.easeIn(1.5))
    );
    pulse.setTag(PointerHandler.HOVER_PULSE_TAG);
    target.runAction(pulse);
};

PointerHandler.stopHoverPulse = function (target) {
    target.stopActionByTag(PointerHandler.HOVER_PULSE_TAG);
};

// target.hoverPulsed remembers that the current hover already got its pulse, so the calls that
// follow while the pointer stays over (a second handler on the same node entering hover, a press,
// a release) don't pulse again. A pulse still playing is left to finish: a node commonly carries
// both a click and a hover handler, and the second one's hover entry lands in the same frame.
PointerHandler.updateHoverPulseScale = function (target, pressedScale) {
    const hovered = PointerHandler.getState(target, "hovered");
    const pressed = PointerHandler.getState(target, "pressed");
    const baseScale = BaseScale(target);

    if (!hovered) {
        target.hoverPulsed = false;
        PointerHandler.stopHoverPulse(target);
        target.setScale(baseScale.x, baseScale.y);
        return;
    }

    if (pressed) {
        PointerHandler.stopHoverPulse(target);
        target.setScale(baseScale.x * pressedScale, baseScale.y * pressedScale);
        return;
    }

    if (!target.hoverPulsed) {
        target.hoverPulsed = true;
        // A tap enters hover and press in one event, so its release is the first call without
        // pressed and would start the entry pulse. When that tap closed the window, the release
        // comes from the handler's destructor during cleanup, and an action on a node being
        // removed is an error in debug mode.
        if (target.isRunning()) {
            PointerHandler.runHoverPulse(target);
        }
        return;
    }

    if (!target.getActionByTag(PointerHandler.HOVER_PULSE_TAG)) {
        target.setScale(baseScale.x, baseScale.y);
    }
};

PointerHandler.prototype._updateInteractiveScale = function () {
    if (!this.interactiveScale) {
        return;
    }

    PointerHandler.updateHoverPulseScale(this.target, 1 / MaxInteractiveScale(this.target));
};

cleverapps.UI.Button.prototype._updateScale = function () {
    PointerHandler.updateHoverPulseScale(this, MaxInteractiveScale(this));
};
